module.exports = __webpack_public_path__ + "img/DragonsVsPandas_DG.c2372c79.jpg";